module.exports = __webpack_public_path__ + "static/media/search.badbd38f.svg";